import { Component, HostBinding, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State, __config_book } from '../../../redux/reducers';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-book-order',
  templateUrl: './book-order.component.html'
})
export class BookOrderComponent implements OnInit {
  @HostBinding() class = 'book-order';
  sellConnectSku$: Observable<string>;

  constructor(private readonly store: Store<State>) {}

  ngOnInit() {
    this.sellConnectSku$ = this.store.pipe(
      select(__config_book),
      filter(bookConfig => !bookConfig.isLoading),
      map(bookConfig => bookConfig.config.sell_connect_sku),
      take(1)
    );
  }

  getRouteParams(sku: string) {
    return sku ? ['/store', sku] : ['/store'];
  }
}
